import { useEffect } from "react";
import api from "./api";

/** Best guess at this device's IANA timezone, e.g. "America/New_York". */
export function browserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch {
    return "";
  }
}

const STORED = "boardroom_reported_timezone";

/**
 * Tells the server which timezone this chair is in, so Monday nudges and
 * reminders land at their own 8am rather than UTC. One PATCH per identity,
 * then only when the zone actually changes (travel, new device). Keyed by
 * identity because signing in switches which account needs it.
 */
export function useReportTimezone(identity) {
  useEffect(() => {
    const tz = browserTimezone();
    if (!tz) return;
    const key = `${STORED}:${identity || "anon"}`;
    let stored = null;
    try {
      stored = localStorage.getItem(key);
    } catch { /* private mode */ }
    if (stored === tz) return;
    api
      .patch("/me", { timezone: tz })
      .then(() => {
        try {
          localStorage.setItem(key, tz);
        } catch { /* private mode */ }
      })
      .catch((e) => console.debug("timezone report skipped", e?.response?.status));
  }, [identity]);
}
